import { ScreenWidthsRange } from './types';
import { MOBILE_MAX_WIDTH, MORE_DROPDOWN_MAX_WIDTH } from '../modules/breakpoints';

export const MOBILE: ScreenWidthsRange = [0, MOBILE_MAX_WIDTH];

export const DESKTOP_MORE_DROPDOWN: ScreenWidthsRange = [MOBILE_MAX_WIDTH + 1, MORE_DROPDOWN_MAX_WIDTH];
export const DESKTOP_COLLAPSE_INTO_MORE_DROPDOWN: ScreenWidthsRange = [MORE_DROPDOWN_MAX_WIDTH + 1, +Infinity];
